/* esm.sh - @radix-ui/react-tabs@1.1.13 */
export * from "/*@radix-ui/react-tabs@1.1.13/esnext/react-tabs.mjs";
